import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { translate } from 'react-i18next';

import Tooltip from 'components/Tooltip';

import { theme } from 'lib/styles';

import {
	Container,
	Name,
	TitleIcon,
} from './styles';

const Title = props => {
	const { t, viewSettings } = props;

	return (
		<ThemeProvider theme={theme}>
			<Container>
				<Name>
					<TitleIcon className="icon" icon={props.icon} />
					<h3>{viewSettings ? t('controls/settings') : props.title}</h3>
				</Name>
				<div>
					{ props.showCog &&
						<Tooltip
						  icon={viewSettings ? 'close' : 'cog'}
						  position="left"
						  tooltip={t(viewSettings ? 'controls/close' : 'controls/settings')}
						  onClickHandler={props.settingsHandler}
						/>
					}
				</div>
			</Container>
		</ThemeProvider>
	)
}

Title.propTypes = {
	t: PropTypes.func,
	icon: PropTypes.string,
	title: PropTypes.string,
	viewSettings: PropTypes.bool,
	showCog: PropTypes.bool,
	settingsHandler: PropTypes.func,
}

export default translate('translations')(Title)
